import { AlertCircle, FileX, TrendingDown, ExternalLink } from 'lucide-react'

interface AttentionItem {
  type: 'missing' | 'low_grade'
  title: string
  course: string
  due_date?: string
  current?: string
  message: string
  html_url?: string
}

interface AttentionSectionProps {
  items: AttentionItem[]
}

export function AttentionSection({ items }: AttentionSectionProps) {
  if (items.length === 0) {
    return null
  }

  return (
    <div className="mb-4">
      <h3 className="text-sm font-medium text-red-400 uppercase tracking-wide flex items-center gap-2 mb-3">
        <AlertCircle className="w-4 h-4" />
        Needs Attention
      </h3>

      <div className="space-y-2">
        {items.map((item, idx) => {
          const content = (
            <div className="flex items-center gap-2">
              {item.type === 'missing' ? (
                <FileX className="w-4 h-4 text-red-400 flex-shrink-0" />
              ) : (
                <TrendingDown className="w-4 h-4 text-orange-400 flex-shrink-0" />
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-200 truncate">{item.title}</p>
                <div className="flex items-center gap-2 text-xs">
                  <span className="text-gray-500">{item.course}</span>
                  {item.current && (
                    <span className="text-orange-400">{item.current}</span>
                  )}
                </div>
              </div>
              <span className="text-xs text-red-300 whitespace-nowrap">
                {item.message}
              </span>
              {item.html_url && (
                <ExternalLink className="w-4 h-4 text-gray-500 flex-shrink-0" />
              )}
            </div>
          )

          return item.html_url ? (
            <a
              key={idx}
              href={item.html_url}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-2 bg-red-900/20 border border-red-500/30 rounded-lg hover:bg-red-900/30 transition-colors"
            >
              {content}
            </a>
          ) : (
            <div
              key={idx}
              className="p-2 bg-red-900/20 border border-red-500/30 rounded-lg"
            >
              {content}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AttentionSection
